import React, { useState } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { motion, AnimatePresence } from 'framer-motion';

export function Popover({ 
    trigger, 
    content, 
    position = 'bottom', 
    isOpen, 
    onOpenChange,
    className = '' 
}) {
    const [internalOpen, setInternalOpen] = useState(false);
    
    const isControlled = isOpen !== undefined;
    const open = isControlled ? isOpen : internalOpen;

    const handleOpenChange = (newOpen) => {
        if (isControlled) {
            onOpenChange?.(newOpen);
        } else {
            setInternalOpen(newOpen);
        }
    };

    const alignMap = {
        'top': 'center',
        'bottom': 'center',
        'left': 'start',
        'right': 'end'
    };

    return (
        <PopoverPrimitive.Root open={open} onOpenChange={handleOpenChange}>
            <PopoverPrimitive.Trigger asChild>
                <div className="cursor-pointer inline-block">
                    {trigger}
                </div>
            </PopoverPrimitive.Trigger>

            <PopoverPrimitive.Portal>
                <AnimatePresence>
                    {open && (
                        <PopoverPrimitive.Content
                            asChild
                            side={position}
                            align={alignMap[position] || 'center'}
                            sideOffset={8}
                        >
                            <motion.div
                                initial={{ opacity: 0, scale: 0.95, y: position === 'bottom' ? -4 : 4, filter: 'blur(4px)' }}
                                animate={{ opacity: 1, scale: 1, y: 0, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, scale: 0.95, y: position === 'bottom' ? -4 : 4, filter: 'blur(4px)' }}
                                transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                                style={{ zIndex: 'var(--z-popover, 1800)' }}
                                className={`
                                    bg-[var(--bg-surface)]/90 backdrop-blur-xl border border-[var(--border)]
                                    shadow-xl rounded-2xl p-1.5 ${className}
                                `}
                            >
                                {content}
                            </motion.div>
                        </PopoverPrimitive.Content>
                    )}
                </AnimatePresence>
            </PopoverPrimitive.Portal>
        </PopoverPrimitive.Root>
    );
}
